import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'
import { getInventoryGroups, inventoryGroupDelete, inventoryExport } from '../actions'
import Groups from './Groups'

const mapStateToProps = state => {
  const countryIsoCode = getFromSettings(state, 'countryIsoCode')

  return {
    isGetGroupsInProgress: state.inventory.isGetGroupsInProgress,
    getGroupsResponse: state.inventory.getGroupsResponse,
    groups: state.inventory.groups,
    groupsItemsCount: state.inventory.groupsItemsCount,
    groupsItemsValue: state.inventory.groupsItemsValue,
    deleteGroupResponse: state.inventory.deleteGroupResponse,
    isDeleteGroupInProgress: state.inventory.isDeleteGroupInProgress,
    isExportInProgress: state.inventory.isExportInProgress,
    exportResponse: state.inventory.exportResponse,
    saveGroupResponse: state.inventory.saveGroupResponse,
    user: state.user.user,
    labels: getFromSettings(state, 'labels', {}),
    features: state.appReducer.features,
    countryIsoCode: countryIsoCode,
  }
}

const mapDispatchToProps = {
  getInventoryGroups,
  inventoryGroupDelete,
  inventoryExport,
}

export default connect(mapStateToProps, mapDispatchToProps)(Groups)
